import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  CardContent,
  Typography,
  Divider,
  TableSortLabel,
  TextField,
  useTheme,
  Grid,
  MenuItem,
  Autocomplete,
  Button,
} from "@mui/material";
import Icons from "../../Utils/Icons";
import { GET } from "../Generic/CrudRequest";
import { searchPermissions } from "../Users/PermissionsUser/PermissionsActions";
import useExcelExport from "../../Utils/useExcelExport";
import { SaveAlt } from "@mui/icons-material";
import { useTranslation } from "react-i18next";


export default function Madrinas(props) {
  const { t } = useTranslation();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("");
  const [column, setColumn] = React.useState(0);
  const [order, setOrder] = React.useState("asc");
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [searchText, setSearchText] = useState("");
  const [locations, setLocations] = useState([]);
  const [idUbicacion, setIdUbicacion] = useState(null);
  const [tipo, setTipo] = useState("");
  const [estatus, setEstatus] = React.useState(true);
  const [register, setRegister] = useState(false);
  const [edit, setEdit] = useState(false);
  const theme = useTheme();
  const { config } = props;
  const exportToExcel = useExcelExport();
  const handleExport = () => {
    const filename = t("madrinas.excelTitle");
    exportToExcel(rows, columns, filename);
  };

  const columns = [
    { id: "numeroEconomico", label: t("madrinas.numeroEconomico"), minWidth: "100px" },
    { id: "modelo", label: t("madrinas.modelo"), minWidth: "100px" },
    { id: "tipoTrailer", label: t("madrinas.tipoTrailer"), minWidth: "100px" },
    { id: "ubicacionNavigation", label: t("madrinas.ubicacion"), minWidth: "100px" },
    { id: "placas", label: t("madrinas.placas"), minWidth: "100px" },
    { id: "placasUsa", label: t("madrinas.placasUsa"), minWidth: "100px" },
    { id: "estatus", label: t("madrinas.estatus"), minWidth: "100px" },
  ];
  useEffect(() => {
    fetchMadrinas();
  }, [page, rowsPerPage, column, order]);

  const fetchMadrinas = async () => {
    const dataMadrinas = await GET(`${config.url}/api/Truck/paginado`, {
      start: page * rowsPerPage,
      length: rowsPerPage,
      noEconomico: searchText,
      idUbicacion: idUbicacion,
      tipo: tipo,
      estatus: estatus,
      column: column,
      dir: order,
    });

    setRows(dataMadrinas.resultado);
    setTotalRecords(dataMadrinas.totalRegistros);

    const permissionsArray = JSON.parse(localStorage.getItem("permissions"));

    const permissionRegister = searchPermissions(
      "Ubicaciones",
      "Registrar",
      permissionsArray
    );

    const permissionEdit = searchPermissions(
      "Ubicaciones",
      "Editar",
      permissionsArray
    );

    setRegister(permissionRegister);
    setEdit(permissionEdit);
  };

  const fetchLocations = async (location, currentPage, perPage) => {
    const dataLocations = await GET(`${config.url}/api/Location/select`, {
      busqueda: location,
      page: currentPage,
      perPage: perPage,
    });

    setLocations(dataLocations.result);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (property, columnNumber) => {
    const isAsc = orderBy === property && order === "asc";
    setColumn(columnNumber);
    setOrderBy(property);
    setOrder(isAsc ? "desc" : "asc");
  };

  const handleSearch = () => {
    fetchMadrinas();
  };

  const handleClear = () => {
    setSearchText("");
    setTipo("");
    setEstatus(true);
    setIdUbicacion(null);
    setLocations([]);
  };

  const handleChangeEstatus = (event) => {
    setEstatus(event.target.value);
  };

  const handleInputChange = (event, value) => {
    if (value.trim().length >= 3) {
      fetchLocations(value, 1, 10); // Initial page and perPage values
    } else {
      setLocations([]);
    }
  };

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      <CardContent>
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
            {t("madrinas.title")}
          </Typography>
          {register && (
            <Icons
              iconName="Add"
              fontSize="large"
              to="/Madrinas/Agregar"
              style={{
                marginLeft: "auto",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.white.main,
              }}
              tooltip={t("madrinas.add")}
            />
          )}
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <CardContent
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            alignItems: "auto",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                label={t("madrinas.numeroEconomico")}
                type="search"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={locations}
                noOptionsText={t("noOptions")}
                getOptionLabel={(location) =>
                  `${location.nombre} ${location.descripcion} ${
                    location.ciudad ?? ""
                  } ${location.ubicacionTipo ?? ""}`
                }
                onChange={(event, value) => {
                  if (value) {
                    setIdUbicacion(value.idUbicacion);
                  }
                }}
                isOptionEqualToValue={(option, value) =>
                  option && value && option.idUbicacion === value.idUbicacion
                }
                onInputChange={handleInputChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("madrinas.ubicacion")}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label={t("madrinas.tipoTrailer")}
                type="search"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                size="small"
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                label={t("madrinas.estatus")}
                InputLabelProps={{
                  shrink: true,
                }}
                name="estatus"
                variant="standard"
                size="small"
                value={estatus}
                fullWidth
                onChange={handleChangeEstatus}
              >
                <MenuItem value={true}>{t("madrinas.active")}</MenuItem>
                <MenuItem value={false}>{t("madrinas.inactive")}</MenuItem>
              </TextField>
            </Grid>
            <Icons
              iconName="Search"
              fontSize="large"
              onClick={handleSearch}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("buttons.search")}
            />
            <Icons
              iconName="Clear"
              fontSize="large"
              onClick={handleClear}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("buttons.clear")}
            />
          </Grid>
        </CardContent>
        <Paper
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            overflow: "hidden",
            boxShadow: "none",
            border: "none",
          }}
        >
          <TableContainer>
            <Button
              variant="contained"
              startIcon={<SaveAlt />}
              onClick={handleExport}
            >
              {t("buttons.exportExcel")}
            </Button>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align="left"
                      style={{ minWidth: column.minWidth, fontWeight: "bold" }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() =>
                          handleRequestSort(column.id, columns.indexOf(column))
                        }
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1} align="center">
                      {t("madrinas.noMadrinasAvailable")}
                    </TableCell>
                  </TableRow>
                )}
                {rows.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      {columns.map((column) => (
                        <TableCell key={column.id} align="left">
                          {column.id === "ubicacionNavigation" ? (
                            row.ubicacionNavigation &&
                            row.ubicacionNavigation.nombre !== "" ? (
                              row.ubicacionNavigation.nombre
                            ) : (
                              <i>{t("madrinas.notAvailable")}</i>
                            )
                          ) : column.id === "estatus" ? (
                            row.estatus === true ? (
                              t("madrinas.active")
                            ) : (
                              t("madrinas.inactive")
                            )
                          ) : row[column.id] !== null &&
                            row[column.id] !== "" ? (
                            row[column.id]
                          ) : (
                            <i>{t("madrinas.notAvailable")}</i>
                          )}
                        </TableCell>
                      ))}
                      <TableCell align="right">
                        {edit && (
                          <Icons
                            iconName="Edit"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.primary.main,
                              color: "#fff",
                            }}
                            to={`/Madrinas/Editar/${row.idTractocamion}`}
                            tooltip={t("madrinas.edit")}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100, { value: -1, label: "Todos" }]}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Elementos por página:"
            labelDisplayedRows={({ from, to, count }) =>
              `Mostrando ${from} - ${to} de ${count} elementos`
            }
          />
        </Paper>
      </CardContent>
    </Card>
  );
}
